import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let ViewportSizeMixin = class ViewportSizeMixin extends Vue {
    get mdAndUp() {
        return this.$vuetify.breakpoint.mdAndUp;
    }
    get mdAndDown() {
        return this.$vuetify.breakpoint.mdAndDown;
    }
    get mdOnly() {
        return this.$vuetify.breakpoint.mdOnly;
    }
    get smAndUp() {
        return this.$vuetify.breakpoint.smAndUp;
    }
    get smAndDown() {
        return this.$vuetify.breakpoint.smAndDown;
    }
    get smOnly() {
        return this.$vuetify.breakpoint.smOnly;
    }
    get xsOnly() {
        return this.$vuetify.breakpoint.xsOnly;
    }
    get lgAndDown() {
        return this.$vuetify.breakpoint.lgAndDown;
    }
    get lgAndUp() {
        return this.$vuetify.breakpoint.lgAndUp;
    }
    get lgOnly() {
        return this.$vuetify.breakpoint.lgOnly;
    }
    get xlOnly() {
        return this.$vuetify.breakpoint.xlOnly;
    }
};
ViewportSizeMixin = __decorate([
    Component
], ViewportSizeMixin);
export default ViewportSizeMixin;
